import React from 'react';
import { Link } from 'react-router-dom';
import { Tab } from '@material-ui/core';
import Slider from 'react-slick';
import HomeView from '../../constants/HomeView';
import { isMobile } from 'react-device-detect';

const Headings = HomeView.HOME_PAGE_HEADERS;

interface CasinoProvidersSliderProps {
  providers: { image: string; text: string }[];
}

const providerSettings = {
  dots: false,
  infinite: true,
  speed: 1000,
  slidesToShow: isMobile ? 4 : 6,
  slidesToScroll: 1,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 500,
  pauseOnHover: true,
};

const CasinoProvidersSlider: React.FC<CasinoProvidersSliderProps> = ({
  providers,
}) => {
  return (
    <>
      {/* Casino Providers */}
      <div className="casino-providers-section web-view">
        <div className="heading-ctn">
          <div className="title">{Headings.casinoCards}</div>
          <div className="text-border-btm"></div>
        </div>
        <Slider {...providerSettings}>
          {providers.map((card, idx) => (
            <Link to={'/casino'}>
              <Tab
                value={0}
                textColor="primary"
                className="hub-card"
                icon={<img loading="lazy" src={card.image} title={card.text} />}
              />
            </Link>
          ))}
        </Slider>
      </div>
      <div className="casino-providers-section mob-view">
        <div className="heading-ctn">
          <div className="title">{Headings.casinoCards}</div>
          <div className="text-border-btm"></div>
        </div>
        {/* <Slider {...providerSettings}> */}
        <div className="provider-cards-ctn">
          {providers.map((card, idx) => (
            <>
              {idx < 6 && (
                <Link to={'/casino'}>
                  <Tab
                    value={0}
                    textColor="primary"
                    className="hub-card"
                    icon={
                      <img loading="lazy" src={card.image} title={card.text} />
                    }
                  />
                </Link>
              )}
            </>
          ))}
        </div>
        {/* </Slider> */}
      </div>
    </>
  );
};

export default CasinoProvidersSlider;
